import { Route } from "@src/routes/routes";
export const obtainReactRouteFromUrl = (url: string) => {
  switch (url) {
    case "/":
      return Route.THINGS_OS_HOMEPAGE;
    case "/machines":
      return Route.MACHINES;
    case "/gateways":
      return Route.GATEWAYS;
    case "/user-management":
      return Route.USER_MANAGEMENT_PAGE;
    case "/tickets":
      return Route.TICKETS_PAGE;
    case "/dashboard-builder":
      return Route.DASHBOARD_BUILDER;
    case "/dashboard":
      return Route.DASHBOARD;
    case "/factory-dashboard":
      return Route.FACTORY_DASHBOARD;
    case "/admin-panel":
      return Route.ADMIN_PANEL;
    default:
      return Route.MACHINES;
  }
};
